// src/pages/documents/RulesFI.js
          //this will be painful to update
import React from 'react';

const EqualityPlan = () => {
  return (
    <div className="page rules-page">
      <section className="page-header">
        <div className="container">
          <h1>Integralis equality plan</h1>
          <p>Updated 2026</p>
          
        </div>
      </section>
      <section className="content-section">
        <div className="container">

          <div className="rule-card">
            
            <p>Upholding equality and creating safe spaces is an important part of fostering a
welcoming and inclusive environment for all our members.</p>

<p>In events organized at Matlu Klusteri, Integralis follows the Safer Space Guidelines of
Matlu ry. Integralis commits to creating and updating our own English language Safer
Space Principles modelled after theirs for our own events. In events organized in HYY
spaces, Integralis follows the Safer Space Guidelines of HYY.</p>

<p>Our events are open to and welcoming to all members, excluding the banned
members.</p>

<h2>Disabilities</h2>
<p>The organisation will take care of members with disabilities and accommodate their
needs when planning events. The organization commits to referring their members
to accessibility resources relevant to our commonly used and other spaces to the best
of our abilities. </p>

<h2>Alcohol Use</h2>
<p>Keeping in mind that our members don’t always want to drink, all events are alcoholoptional and non-alcoholic options will always be provided when alcohol is served.
Pressuring someone to drink when they don’t want to constitute harassment.
Integralis commits to organising alcoholic, low-alcoholic and non-alcoholic events.</p>

<h2>Nudity and sexual content</h2>
<p>To keep our events and spaces comfortable for all members, sexual content is not
permitted in our spaces (including all our online spaces). Nudity is only allowed at
events where it is appropriate (e.g. sauna nights) and only when all participants
consent to it.
</p>

<h2>Sauna Policy</h2>
<p>During Integralis’ sauna events, sauna sessions will be divided into the following shifts
to ensure a safe and comfortable experience for all members: </p>
<ul>
  <li>Non-male</li>
  <li>Non-female</li>
  <li>Mixed</li>
</ul>

<h2>Special diets</h2>
<p>We consider the dietary restrictions of our members for our events (e.g. allergies,
veganism) and will provide vegan-equivalent options at events where food is
expected to be provided as per our environmental plan. We aim to provide allergysafe 
food options if requested by a member during certain events (eg. Sitsit). </p>

<h2>Transparency of operation</h2>
<p>We aim to keep the organisation’s operations entirely transparent to all members. All
board meetings are open to all members. All members are encouraged to read the
minutes of the meetings, give suggestions and participate in organisational work. The
board is allowed to host private meetings if necessary to discuss sensitive issues
(issues involving legal, disciplinary or confidential personal information (e.g.
discussing the removal, extension, or termination of a member's ban)). </p><p>A general
summary of such meetings, excluding confidential details, will be included in the
meeting minutes available to members. Any affected party by decisions made during
the private meeting must be notified and provided an opportunity to appeal.</p>

<h2>Language use</h2>
<p>The primary language of the organization is English. However, Integralis does not
discriminate based on proficiency in English or any other language. At Integralis
events, members are free to communicate in any language during casual
conversations. We encourage people to share their own language and culture with
other members. To effectively carry out their responsibilities, board members are
required to have sufficient English skills for organizational communication.</p>

<h2>Implementation</h2>
<ol>
  <li>Ensure the filling of 2-4 anti-harassment positions and if possible, an equality officer
position, preferably ensuring gender diversity. </li>
<li>Ensure all anti-harassment contact people are clearly listed on the Integralis
website.</li>
<li> Ensure the Safer Space Principles are easily available to attendees of events. </li>
<li>Ensure an anonymous harassment report system.</li>
<li> If possible, provide organized official training for anti-harassment people. </li>
</ol>
<br></br>
<p>This document has been approved at the Statutory Meeting on the 26th of March 2026.</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default EqualityPlan;

